module.exports = __webpack_public_path__ + "assets/img/gpsMapCamera.fc1b2f5e.png";